import { darkTheme } from './dark';
import { lightTheme } from './light';

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};

// Export common utilities
export { borderRadius } from './common/borderRadius';
export { getComponents } from './common/components';
export { spacing } from './common/spacing';
export { buildTypography, typography, typographyKinds } from './common/typography';

// Export type definitions for augmentation
export type * from './theme';
